import SmartToyOutlinedIcon from '@mui/icons-material/SmartToy'

const ChatIcon = ({ width }: { width?: number }) => {
  return <SmartToyOutlinedIcon color="primary" />
}

export default ChatIcon
